import { Navigate } from 'react-router-dom';

export const RedirectToLoginPage = () => {
  return <Navigate to="/login" replace />;
};

export const redirectToLogin = async () => {
  window.location.replace('/login');
};
